import { render } from "./AccountComponent.vue?vue&type=template&id=6022b61b&scoped=true"
import script from "./AccountComponent.vue?vue&type=script&lang=js"
export * from "./AccountComponent.vue?vue&type=script&lang=js"

import "./AccountComponent.vue?vue&type=style&index=0&id=6022b61b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6022b61b"]])

export default __exports__